const messages = {
  ExemptWalletLimit: "Use at most 10 additional exempt wallets.",
  AlreadyConfigured: "This pool's anti-sniper settings are already configured.",
  Unauthorized: "This wallet is not authorized to perform this operation.",
};

export function launchpadError(error: unknown): string {
  const fallback = error instanceof Error ? error.message : String(error);
  let current = error;
  const visited = new Set<unknown>();
  while (current && typeof current === "object" && !visited.has(current)) {
    visited.add(current);
    const value = current as { message?: unknown; data?: { errorName?: unknown }; cause?: unknown };
    for (const [name, message] of Object.entries(messages)) {
      if (value.data?.errorName === name || (typeof value.message === "string" && new RegExp("\\b" + name + "\\b").test(value.message))) return message;
    }
    current = value.cause;
  }
  return fallback;
}
